import { trustBadges } from '@/mocks/categories';

export default function TrustBar() {
  return (
    <div className="bg-background-100 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-4">
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-10">
          {trustBadges.map((badge) => (
            <div key={badge.label} className="flex items-center gap-2 text-foreground-600">
              <i className={`${badge.icon} text-primary-500 text-base w-5 h-5 flex items-center justify-center`}></i>
              <span className="text-xs md:text-sm font-medium whitespace-nowrap">{badge.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}